import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AllticketComponent } from './allticket/allticket.component';
// import { AssetstatusreportComponent } from './assetstatusreport/assetstatusreport.component';
import { PmsProfileReportComponent } from './pms-profile-report/pms-profile-report.component';

const routes: Routes = [
  // {
  //   // path: 'allticket', component: AllticketComponent
  // },
  {
    // path: 'report/assetStatusReport', component:AssetstatusreportComponent
  },
  {
    path:'pmsProfileReport', component:PmsProfileReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class reportRoutingModule { }
